import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExampleNumberWidgetComponent } from './example-number-widget.component';



@NgModule({
  declarations: [ExampleNumberWidgetComponent],
  imports: [
    CommonModule
  ],
  exports: [ExampleNumberWidgetComponent]
})
export class ExampleNumberWidgetModule { }
